import React from "react";
import { Route } from "react-router-dom";
import { Home } from "./components/Home";

export const routes = <Route path="/" component={Home} />;
